import { CompanyForm } from '../../models/company.model'
import { CompanyFormDto } from '../dto/company.dto'

export const companyFormModelToDtoTransformer = (model: CompanyForm): CompanyFormDto => {
  return {
    Name: model.name,
    PlaceOR: model.address,
    PLZ: model.zipCode,
    Address: model.city,
    Land: model.country,
    sapCustomerID: model.sapCustomerId === '' ? null : model.sapCustomerId,
    Telefon: model.phone,
    Telefax: model.fax,
    Email: model.email,
    shopPermission: model.sapCustomerId ? model.shopPermission : undefined,
  }
}
